import useTranslation from 'next-translate/useTranslation';
import { MultiplierProps } from './props';
import styles from './styles.module.scss';

export default function GameMultiplier({
  color,
  multiplier,
  text,
  isClosed,
  shouldShowLastWinnerBets,
  hideText = false,
  rowVariant,
}: MultiplierProps) {
  const { t } = useTranslation('common');

  return (
    <div
      className={`${styles.column} ${rowVariant ? styles['column--row'] : ''}`}
    >
      <div
        className={styles.column__multiplier}
        style={{
          color:
            (isClosed || !shouldShowLastWinnerBets) && color
              ? color
              : undefined,
        }}
      >
        {multiplier}X
      </div>
      {!hideText && (
        <div
          className={`${styles.column__card} ${isClosed ? styles['column__card--closed'] : ''}`}
          style={{
            color: isClosed && color ? color : undefined,
          }}
        >
          {text ?? t('crash_label')}
        </div>
      )}
    </div>
  );
}
